
import Vue from "vue";
import $ from "jquery";
import filters from "@/filters";
import Component from "vue-class-component";
import { Action, State } from "vuex-class";
import { AxiosResponse } from "axios";
import { createPagination, defaultPagination } from "@/functions/pagination.function";
import { PaginationState } from "@/store/types";
import { Prop, Watch } from "vue-property-decorator";
import { SCHOOL_PARTNERSHIP } from "@/constants/enum.constant";
import ModalApprove from "@/views/apps/partnership/ModalApproveExtend.vue";
import ModalReject from "@/views/apps/partnership/ModalReject.vue";

@Component({
  components: {
    ModalReject,
    ModalApprove
  },
  filters,
})
export default class Pending extends Vue {
  @Action("actionGetPending", { namespace: "partnership" })
  private actionGetPending: any;
  @Action("actionPagination", { namespace: "partnership" })
  private actionPagination: any;

  @State("locale")
  private locale: any;

  @Prop({default: null})
  private industry: any;
  @Prop({default: ""})
  private name: string;
  @Prop({default: false})
  private filter: boolean;

  @Watch("filter")
  private onFilter() {
    this.getData();
  }

  private modalApprove: boolean = false;
  private modalReject: boolean = false;
  private currentId: number = 0;
  private currentTempId: number = 0;
  private onLoad: boolean = false;
  private partnerships: Array<any> = [];
  private pagination: PaginationState = defaultPagination;
  private activePage: number = 1;

  private mounted() {
    const self = this;
    this.getData();
    $(document).ready(function () {
      $(".partnership-section").scroll(function () {
        if (($(this).scrollTop() as number) + ($(this).innerHeight() as number) >= $(this)[0].scrollHeight) {
          if (!self.onLoad) {
            if (self.partnerships.length === 0) return;
            if (self.onLoad) return;
            if (self.pagination.url && !self.onLoad) {
              setTimeout(() => {
                self.getData(self.activePage, self.pagination.url);
              }, 200);
            }
          }
        }
      });
    });
  }

  private getData(page: number = 1, url: string = "") {
    let params = {};
    // @ts-ignore
    if (this.industry) params.industry = this.industry.id;
    // @ts-ignore
    params.company_name = this.name;
    this.onLoad = true;
    if (url) {
      this.actionPagination({
        params: {
          url: url,
          page: page,
          ...params
        },
        success: (response: AxiosResponse) => {
          this.setData(response);
        },
      });
    } else {
      this.actionGetPending({
        params: params,
        success: (response: AxiosResponse) => {
          this.activePage = 1;
          this.setData(response);
        },
      });
    }
  }

  private setData(response: AxiosResponse) {
    if (response.data.next) this.activePage++;
    this.onLoad = false;
    this.partnerships = response.data.results;
    this.pagination = createPagination(response.data);
  }

  private getBadge (status: number) {
    if (status === SCHOOL_PARTNERSHIP.PENDING) return require("@/assets/images/partnership/pending.png")
    else if (status === SCHOOL_PARTNERSHIP.REJECTED) return require("@/assets/images/partnership/rejected.png")
    else if (status === SCHOOL_PARTNERSHIP.EXPIRED) return require("@/assets/images/partnership/expired.png")
    else return require("@/assets/images/partnership/verified.png")
  }

  private getIndustryName(data: any) {
    if (data) {
      if (this.locale === "id") return data.translation;
      return data.name;
    } else {
      return "-";
    }
  }

  private getLogo(partnership: any) {
    return partnership[
      partnership.company_id ?
        "company" :
        "company_temporary"
      ][
      partnership.company_id ?
        "company_logo" :
        "logo"
      ] || require("@/assets/Photo/photo_placeholder-company.jpg")
  }
}
